import moment from "moment";

export function getEndOfCurrentDay(timezone: string): number {
  return moment.tz(timezone)
    .set('hours', 23)
    .set('minutes', 59)
    .set('seconds', 59)
    .set('milliseconds', 999)
    .valueOf()
}